import PropTypes from 'prop-types';
import React from 'react';
import MdClose from 'react-icons/lib/md/close';
import { FormattedMessage } from 'react-intl';

import './styles/ActionLogListing.scss';

const AlPropTypes = {
  clearActionLog: PropTypes.func.isRequired,
  al: PropTypes.object.isRequired,
};

const ActionLog = ({ al, clearActionLog }) => {
  /* Single action log entry.
   * Sets timeout to dismiss the action log when mousemove event is
   * registered. The timeout is cancelled on hover on the action log.
   * The mousemove event listener is removed after first firing.
   */
  const DISMISS_TIMEOUT = 15000;
  let dismissTimer = null;
  const dismiss = () => {
    clearActionLog({ al });
  };
  const setDismiss = () => {
    document.removeEventListener('mousemove', setDismiss);
    dismissTimer = window.setTimeout(dismiss, DISMISS_TIMEOUT);
  };
  const cancelDismiss = () => {
    window.clearTimeout(dismissTimer);
  };
  document.addEventListener('mousemove', setDismiss);

  return (
    <div
      styleName={`log ${al.level}`}
      key={al.created}
      onMouseOver={cancelDismiss}
    >
      <FormattedMessage
        id={al.messageId}
        defaultMessage={al.defaultMessage}
        values={al.messageValues || {}}
      />
      <button onClick={dismiss}>
        <MdClose />
      </button>
    </div>
  );
};

ActionLog.propTypes = AlPropTypes;

const propTypes = {
  clearActionLog: PropTypes.func,
  actionLog: PropTypes.array,
};

const defaultProps = {
  actionLog: [],
  clearActionLog: () => {},
};

const ActionLogListing = ({ actionLog, clearActionLog }) =>
  <div styleName='ActionLogListing'>
    {actionLog
      .filter(al => !al.read)
      .map(al => <ActionLog al={al} clearActionLog={clearActionLog} />)
    }
  </div>;

ActionLogListing.propTypes = propTypes;
ActionLogListing.defaultProps = defaultProps;

export default ActionLogListing;
